export default "__VITE_ASSET__C$XZmZ5S__"